angular.module("App.video.details", [
    "App.video.service",
    "jv.Common.Directives.VideoPlayer",
    "jv.Common.Directives.fallbackImage",
    "jv.Common.Directives.PageRefresh"
]);
